<template>
 <div>
   <section class="main_first dark white-logo">
     <div class="container">
       <div class="main-title">
         <div id="typed-strings">
           <p>PCHELP.1oo0.ru</p>
         </div>
         <span class="main-title_typed"></span>
       </div>

       <div class="main-content d-flex justify-content-between">
         <div class="main-content__offer">
           <p>Ремонт компьютеров/<br> /Ремонт ноутбуков / Настройка серверов /<br> / Очистка ПК от вирусов /</p>

         </div>
         <div class="main-content__about ">
           <p>Здравствуйте. мы занимаемся компьютерами</p>
           <p>и все что с ними связано</p>
           <p>Услуга  <router-link class="btn side4" tag="a"
                             :to="{name: 'service_page', params: {service_id:lead.category.last_id  }}">{{ lead.category.name }}</router-link></p>
         </div>
       </div>
     </div>

   </section>

   <section class="section section-shaped section-lg content_background_white my-0" style="">

     <div class="container " v-if="is_load" >

       <div class="row">

         <div class="col-lg-12 card">
           <h2 class="text-megablue">Подтверждение начало работы</h2>
           <editorjsrender class="ml-3" v-if="is_load " :blocks_json="lead.project_data.blocks"></editorjsrender>



         </div>

         <div class="col-lg-12 card mt-2 pt-2">
           <p v-if="islogin==false">Для продолжения работы, вам необходимо авторизоваться через Telegram</p>
           <p v-if="islogin==true">Для продолжения работы, вам необходимо подтвердить создание проекта.</p>



           <button class="btn side4 m-2" v-if="islogin==false" @click="callModalLogin">
             Для продолжения необходимо авторизоваться
           </button>
           <button   class="btn side4 m-2" v-if="islogin==true" @click="confirmProject">
             Подтвердить создание проекта
           </button>
         </div>




       </div>
       <div class="row" v-if="islogin && lead.developer_id==null">
        <div class="col-12 alert-dark">
          <p>После подтверждения проекта, ваш проект уйдет на оценку исполнителям</p>
        </div>
       </div>
       <div class="row" v-if="islogin && lead.developer">
         <div class="col-12 alert alert-success">
           <p>После подтверждения проекта, вашим исполнителем будет  <a class="btn side3" :href="'https://t.me/'+lead.developer.username" target="_blank">@{{ lead.developer.username }}</a></p>
         </div>
       </div>

     </div>
   </section>
   <section class="section section-lg content_background_color_blue2">
     <div class="container">




       <div class="  row row-grid align-items-center"     >
         <div class="col-md-6 order-md-2">
           <img src="/img/features/list_proj.jpg" class="img-fluid floating">
         </div>
         <div class="col-md-6 order-md-1">
           <h2 class="text-white">Постоянный доступ к проекту</h2>
           <div class="pr-md-5" >
            <p class="text-white">После подтверждения создания проекта, у вас будет постоянный доступ в систему где вы сможете контролировать ход ведения проекта</p>
           </div>
         </div>
       </div>
     </div>
   </section>

   <section class="section section-lg content_background_white">
     <div class="container">




       <div class="  row row-grid align-items-center"     >
         <div class="col-md-6 order-md-2">
           <img src="/img/features/canban.jpg" class="img-fluid floating">
         </div>
         <div class="col-md-6 order-md-1">
           <h2>Умная Канбан-доска</h2>
           <div class="pr-md-5" >
             <p>После подтверждения создания проекта, вы сможете видеть прогресс по работе над вашим проектом с помощью умной канбан-доски, которая будет сохранять последние ваши фильтры.</p>
           </div>
         </div>
       </div>
     </div>
   </section>
   <section class="section section-lg content_background_color_blue2">
   <div class="container">




     <div class="  row row-grid align-items-center"     >
       <div class="col-md-6 order-md-2">
         <img src="/img/features/post.jpg" class="img-fluid floating">
       </div>
       <div class="col-md-6 order-md-1">
         <h2 class="text-white">База знаний</h2>
         <div class="pr-md-5" >
           <p class="text-white">После подтверждения создания проекта, у вашего проекта будет база знаний, где разработчик сможет размещать инструкции для пользователя. А также критически важную для вашего проекта информацию</p>
         </div>
       </div>
     </div>
   </div>
   </section>
   <section class="section section-lg content_background_white">
     <div class="container">




       <div class="  row row-grid align-items-center"     >
         <div class="col-md-6 order-md-2">
           <img src="/img/features/addtask.jpg" class="img-fluid floating">
         </div>
         <div class="col-md-6 order-md-1">
           <h2>Поддержка</h2>
           <div class="pr-md-5" >
             <p>По завершению проекта, у вас всегда останется доступ в систему для того чтобы вы могли добавить задачу на будущие доработки вашего проекта</p>
           </div>
         </div>
       </div>
     </div>
   </section>
 </div>
  <!-- 1st Hero Variation -->


</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Api from "../models/Api";
import Modal from "@/components/Modal";
import CircleChart from "@/models/CircleChart";
import vueKanban from 'vue-kanban'
import itemTemplate from '@/components/itemTemplate.vue';
import Editorjsrender from "@/models/Editorjsrender";

export default {
  name: "confirm",

  data() {

    var app = this;

    return {
      "user":null,
      "is_load":false,
      "islogin":false,
      "lead":null,
      "image_url":null,



    }
  },

  mounted: function () {

    var app = this;
    app.image_url = Vue.config.IMAGE_URL;
    let id = app.$route.params.id;
    Api.loadOrder(id,function(data){
      app.lead=data.lead;
      app.is_load=true;
    })

    if (app.$store.getters.ISAUTH) {
      var tmpUser = app.$store.getters.USER;

      app.user = tmpUser;
      app.islogin = true;


    }

    eventBus.$on('user_is_login', user => {
      this.islogin = false;
      if (typeof user === 'object') {
        if (user.api_token) {
          app.user = user;
          app.islogin = true;

        }
      }


    });








  },
  methods: {
    confirmProject(){
      var id=this.lead.secretId;
      var app=this;
      Api.confirmOrder(id,function(){
        app.$router.push({name: 'home', params: { "rand": Math.random()}});
      })
    },
    callModalLogin() {
      eventBus.$emit("call_modal_add_project", {type: "login",})
      {

      }
    },



  },
  components: {Modal,'editorjsrender': Editorjsrender,}
};
</script>